import "layouts/Home/Home.css";
import React from "react";
import NoImage from "../../../assets/img/Letflow/no-image.jpg";
import SavedQueryImage from "../../../assets/img/Letflow/savedQuery.jpg";
import PlaylistImage from "../../../assets/img/Letflow/playlist.jpg";
import FavoriteImage from "../../../assets/img/Letflow/favorite.jpg";
import {Tooltip} from "@material-ui/core";
import {request} from "../../../api-client";
import EventManager, {events} from "../../../utils/EventManager";
import {GAevent, generateLink, getRefreshToken} from "../../../api-client/core/authentication/utils";
import localization from "../../../config/localization";
import GlobalAddToPlaylistDialog from "../../../components/Letflow/AddToPlaylistDialog/GlobalAddToPlaylistDialog";
import ShareDialog from "../../../components/Letflow/ShareDialog";
import Link from "react-router-dom/Link";
import styleFixed from "./Styles/Grid/directors.module.css"
import hoverStyleX6 from "./Styles/Grid/musicRecommended.module.css";
import styleX4 from "./Styles/Grid/musicLibrary.module.css";
import styleX4Round from "./Styles/Grid/gridX4Round.module.css";
import {ReactComponent as Star} from "../../../components/Letflow/SvgIcons/star.svg"
import {ReactComponent as List} from "../../../components/Letflow/SvgIcons/list.svg"
import {ReactComponent as Heart} from "../../../components/Letflow/SvgIcons/heart.svg"
import {ReactComponent as Share} from "../../../components/Letflow/SvgIcons/share.svg"
import {ReactComponent as Person} from "../../../components/Letflow/SvgIcons/person.svg"
import {ReactComponent as Group} from "../../../components/Letflow/SvgIcons/groups.svg";
import AddToPlaylist from "../../../components/Letflow/AddToPlaylist";

class GridItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      favorite: props.data.favorite,
      id: this.props.data.id,
      showShareDialog: false,
      playlistToShareId: null,
      limitReached: false
    };
  }

  componentDidMount = () => {
    EventManager.getInstance().subscribe(events.ADD_TO_FAVORITE_ITEM_DESCRIPTION, this.addToFavoriteItemDescription)
    EventManager.getInstance().subscribe(events.REMOVE_FROM_FAVORITE_ITEM_DESCRIPTION, this.removeFromFavoritesItemDescription)
    this.checkViewsLimit()
  }

  componentWillUnmount = () => {
    EventManager.getInstance().unsubscribe(events.ADD_TO_FAVORITE_ITEM_DESCRIPTION, this.addToFavoriteItemDescription)
    EventManager.getInstance().unsubscribe(events.REMOVE_FROM_FAVORITE_ITEM_DESCRIPTION, this.removeFromFavoritesItemDescription)
  }

  checkViewsLimit = () => {
    if (this.props.data.view_limit > 0 && this.props.data.views >= this.props.data.view_limit) {
      this.setState({limitReached: true})
    }
  }

  addToFavoriteItemDescription = ({id, type}) => {
    this.addToFavorites({id, type})
  }

  removeFromFavoritesItemDescription = ({id, type}) => {
    this.removeFromFavorites({id, type})
  }

  addToFavorites = ({id, type}) => {
    if(id === this.state.id && this.props.data.kind === type) {
      this.setState({favorite: true})
      EventManager.getInstance().dispatch(events.ADD_TO_FAVORITE_BUTTON_PRESS, {id, type});
    }
  }

  removeFromFavorites = ({id, type}) => {
    if(id === this.state.id && this.props.data.kind === type) {
      this.setState({favorite: false})
      EventManager.getInstance().dispatch(events.REMOVE_FROM_FAVORITE_BUTTON_PRESS, {id, type});
    }
  }

  handleAddContentCreatorToPlaylist = (contentCreator) => {
    GlobalAddToPlaylistDialog.show({
      type: 'contentCreator',
      contentCreatorType: contentCreator.type.slug,
      selectedTrack: contentCreator,
    });
  };

  renderShareDialog = () =>
    <ShareDialog
      show={this.state.showShareDialog}
      handleClose={() => this.setState({showShareDialog: false})}
      entity={'playlist'}
      id={this.state.playlistToShareId}
    />

  toggleModalFavorite = () => this.setState({favorite: !this.state.favorite});

  openContentCreatorModal = () => {
    EventManager.getInstance().dispatch(events.OPEN_CONTENT_MODAL, {id: this.props.data.kind === 'video_content_creation' ? this.props.data.content_creator_id : this.props.data.id, dataType: "contentCreator", dataName: this.props.data.kind === 'video_content_creation' ? '' : this.props.data.name, onTagChange: this.props.handleNewSearch || false});
  }

  makeFavoriteButton = (data, favorite, icon) => {
    if (!this.state.limitReached) {
      let onClick = ''
      GAevent('Contenido', "Favorite", data.name || data.title)
      if (favorite) {
        onClick = (e) => {
          e.preventDefault();
          e.stopPropagation()
          this.removeFromFavorites({id: data.id, type: this.props.data.kind})
        }
      } else {
        onClick = (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.addToFavorites({id: data.id, type: this.props.data.kind})
        }
      }

      switch (icon) {
        case 'star':
          return <Star onClick={onClick}/>
        case 'heart':
          return <Heart onClick={onClick}/>
        case 'list':
          return <List onClick={onClick}/>
      }
    }
  }

  render = () => {
    const { data, onClick } = this.props;
    const style = this.props.fixedTitle ? styleFixed : this.props.maxPerRow === 6 ? hoverStyleX6 : this.props.shape === 'round' ? styleX4Round : styleX4;

    return (
    <>
      {this.state.limitReached &&
      <Tooltip placement={"top"} title={localization.get('content.views_limit_reached')}>
        <Group className={style['limit-reached']}/>
      </Tooltip>
      }
      <Link
        rel="canonical"
        className={`${style['photo-container']} ${this.props.withBackground && style['background']}`}
        to={generateLink(data.kind, data.id, data.title || data.name, false)}
        onClick={(e) => {
          if (!['artist','production', 'content_creator', 'playlist'].includes(data.kind)) {
            e.preventDefault();
            onClick();
          } else if (data.kind === 'content_creator') {
            e.preventDefault();
            if (this.state.limitReached) {
              EventManager.getInstance().dispatch(events.OPEN_VIEWS_LIMIT_MODAL);
            } else {
              this.openContentCreatorModal();
            }
          }
        }}
      >
        <div
          className={style['photo']}
          style={{
            cursor: "pointer",
            backgroundImage: `url(${data.image ? request.file.image.makeCroppedUrl(data.image.id, 400, 400, 'file', 'jpg')
                : data.kind && data.kind === "savedQuery"
                  ? SavedQueryImage
                  : data.kind && data.kind === "playlist"
                    ? PlaylistImage
                    : data.kind && data.kind === "favorite"
                      ? FavoriteImage
                      : NoImage
            })`,
          }}
        >
        </div>
      </Link>

        {(['content_creator', 'video_content_creation', 'playlist'].includes(data.kind)) &&
          <div
            className={style['info']}
            onClick={(e) => {
              if (!['artist','production', 'content_creator', 'playlist'].includes(data.kind)) {
                e.preventDefault()
                onClick()
              } else if (data.kind === 'content_creator') {
                this.openContentCreatorModal()
              }
            }}
          >
            <div className={`${style["title"]}`}>
              {data.title || data.name}
            </div>
            {!this.props.fixedTitle && data.kind === 'album' &&
            <div className={`${style["text"]}`}>
              {data.artist ? data.artist.name : data.subtitle}
            </div>
            }
          </div>
        }

        {['content_creator', 'playlist',  'video_content_creation'].includes(this.props.data.kind) &&
        <div className={style['icons']}>
          {data.kind === "video_content_creation" &&
          <Tooltip placement="bottom" title={localization.get("go_to_content_creator")}>
            <div className={style['list']}>
              <Person onClick={(e) => {
                e.stopPropagation();
                this.openContentCreatorModal()
              }}/>
            </div>
          </Tooltip>
          }

          {data.kind === "playlist" &&
          <Tooltip placement="bottom" title={localization.get("share")}>
            <div className={style['list']}>
              <Share onClick={() => this.setState({showShareDialog: true, playlistToShareId: data.id})}/>
            </div>
          </Tooltip>
          }

          {(data.kind === "content_creator" || data.kind === "video_content_creation") &&
            <div className={style['list']}>
              <AddToPlaylist
                id={data.id}
                content={data.kind === "content_creator" ? "contentCreators" : "contentCreations"}
                onClick={(e) => e}
                icon={
                  <Tooltip placement="bottom" title={localization.get("add_to_playlist")}>
                    <List/>
                  </Tooltip>
                }
              />
            </div>
          }
          <Tooltip placement="bottom" title={localization.get(this.state.favorite ? "soundbar.remove_from_favorites" : "soundbar.add_to_favorites")}>
            <div className={`${style['star']} ${this.state.favorite && style['active']}`}>
              {this.makeFavoriteButton(data, this.state.favorite, 'star')}
            </div>
          </Tooltip>
        </div>
      }
        <div className="album-grid-expand album-info" />
      {this.renderShareDialog()}
    </>
    );
  };
}

export default GridItem;
